// src/core/services/employee.service.ts
import api from "@/core/services/axios";
import { withQuery } from "@/core/utils/queryParams";
import { type Employee } from "@/models";
import { RoleEnum } from "@/core/enum";

export class EmployeeService {
  constructor(private readonly baseRoute = "/employees") {}

  async fetchEmployees(criteria: any) {
    const url = withQuery(this.baseRoute, criteria);
    const res = await api.get(url);
    return res.data;
  }

  async fetchEmployeesExport(criteria: any) {
    const url = withQuery(`${this.baseRoute}/export`, criteria);
    const res = await api.get(url);
    return res.data;
  }

  async fetchEmployeeById(id: string): Promise<Employee> {
    const res = await api.get(`${this.baseRoute}/${id}`);
    return res.data;
  }

  async postRole(employeeId: string, role: RoleEnum): Promise<Employee> {
    const res = await api.post(`${this.baseRoute}/${employeeId}/role`, { type: role });
    return res.data;
  }

  async fetchEmployeesExpiredResumes(criteria: any) {
    const url = withQuery(`${this.baseRoute}/expired-resumes`, criteria);
    const res = await api.get(url);
    return res.data;
  }

  async updateEmployee(updatedEmployee: Employee): Promise<Employee> {
    const res = await api.put(`${this.baseRoute}/${updatedEmployee.id}`, updatedEmployee);
    return res.data;
  }

  async toggleBilingualStatus(employeeId: string, bilingual: boolean): Promise<Employee> {
    const res = await api.post(`${this.baseRoute}/${employeeId}?bilingual=${bilingual}`);
    return res.data;
  }

  async deleteEmployee(employeeId: string): Promise<void> {
    await api.delete(`${this.baseRoute}/${employeeId}`);
  }

  async createBlankEmployee(
    id: string,
    email: string,
    firstName: string | null,
    lastName: string | null
  ): Promise<Employee> {
    const url = withQuery(`${this.baseRoute}/${id}`, {
      create: true,
      email,
      firstName,
      lastName,
    });

    const res = await api.get(url);
    return res.data;
  }
}

// export a singleton (common pattern)
export const employeeService = new EmployeeService();
